import { GetObjectPropertyHelperBase } from './GetObjectPropertyHelperBase';
export class GetPropertyObjectPropertyHelper extends GetObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getPropertyObject;
    }
}

//# sourceMappingURL=GetPropertyObjectPropertyHelper.js.map
